import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import Careersection from '../components/Careersection';
import PageMeta from '../components/PageMeta';

const Careerpage = () => {
  return (
    <>
      <PageMeta
        title="Careers - GuestLinkup"
        description="Join GuestLinkup and help build the platform connecting travelers with authentic family-run homestays across the Himalayan Northeast. Current openings: Operations Manager, Marketing Manager."
      />
      <Header />
      <Careersection />
      <Footer />
    </>
  )
}

export default Careerpage
